<template>
  <div class="form-add">
    <validation-observer ref="simpleRules">
      <b-form class="mcc-form">
        <div class="form-add-nav p-2 mt-1">
          {{ i18n('form.tab.personal') }}
        </div>
        <b-row class="form-add-body p-2">
          <b-col
            v-for="(col, col_i) in columnsPersonal"
            :key="col.field || col_i"
            :md="col.span || 4"
          >
            <b-form-group :label-for="`v-add-${col.field}`">
              <my-tooltip :tooltip="col.SearchTooltip" show-icon>
                <label
                  v-if="!col.hide"
                  :class="{ required: hasRequired(col.formOption) }"
                  class="mcc-form-label"
                  >{{ col.label }}:</label
                >
              </my-tooltip>
              <validation-provider
                class="ss"
                #default="{ errors }"
                :name="col.label"
                :rules="col.formOption ? col.formOption.rules : ''"
              >
                <div
                  v-if="col.field === 'mobile'"
                  :class="{
                    duplicatedBox: showMobileDuplicated,
                    NoduplicatedBox: showMobileSuccess,
                  }"
                >
                  <el-input
                    placeholder="Mobile"
                    v-model="form.mobile"
                    type="number"
                    @input="mobileInput"
                  >
                    <el-select
                      style="width: 90px"
                      v-model="form.mobileCode"
                      slot="prepend"
                      filterable
                      :filter-method="customFilter"
                      @change="mobileCodeChange"
                    >
                      <el-option
                        v-for="country in filteredCountries"
                        :key="country.code"
                        :label="country.nameLabel"
                        :value="country.zone"
                      >
                      </el-option>
                    </el-select>
                    <i
                      v-if="showMobileSuccess"
                      slot="append"
                      class="el-icon-circle-check"
                    ></i>
                    <i
                      v-if="showMobileDuplicated"
                      slot="append"
                      class="el-icon-circle-close"
                    ></i>
                  </el-input>
                  <div v-if="showMobileDuplicated" class="duplicated_msg">
                    The mobile you entered is duplicated
                  </div>
                </div>
                <div
                  v-else-if="col.field === 'email'"
                  :class="{
                    duplicatedBox: showEmailDuplicated,
                    NoduplicatedBox: showEmailSuccess,
                  }"
                >
                  <el-input
                    placeholder="Email"
                    v-model="form.email"
                    @input="emailInput"
                  >
                    <i
                      v-if="showEmailSuccess"
                      slot="append"
                      class="el-icon-circle-check"
                    ></i>
                    <i
                      v-if="showEmailDuplicated"
                      slot="append"
                      class="el-icon-circle-close"
                    ></i>
                  </el-input>
                  <div v-if="showEmailDuplicated" class="duplicated_msg">
                    The Email you entered is duplicated
                  </div>
                </div>
                <div v-else>
                  <element-component
                    v-if="!col.hide"
                    :id="`v-add-${col.field}`"
                    v-model="form[col.field]"
                    :state="errors.length > 0 ? false : null"
                    :label="col.label"
                    :disabled="col.disabled"
                    :option="col"
                  />
                </div>

                <template v-if="col.disabled && !form[col.field]">
                  <small class="text-primary">{{ col.small }}</small>
                </template>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="form-add-line" />
        <div class="form-add-nav p-2 mt-1">
          {{ i18n('form.tab.employment') }}
        </div>

        <b-row class="form-add-body p-2">
          <b-col
            v-for="(col, col_i) in columnsEmployment"
            :key="col.field || col_i"
            :md="col.span || 4"
          >
            <b-form-group :label-for="`v-add-${col.field}`">
              <my-tooltip :tooltip="col.SearchTooltip" show-icon>
                <label
                  class="mcc-form-label"
                  :class="{ required: hasRequired(col.formOption) }"
                  >{{ col.label }}:</label
                >
              </my-tooltip>
              <validation-provider
                #default="{ errors }"
                :name="col.label"
                :rules="col.formOption ? col.formOption.rules : ''"
              >
                <div
                  v-if="col.field === 'staffNo'"
                  :class="{
                    duplicatedBox: showStaffNoDuplicated,
                    NoduplicatedBox: showStaffNoSuccess,
                  }"
                >
                  <el-input
                    placeholder="EmployeeCode"
                    v-model="form.staffNo"
                    @input="StaffNoInput"
                  >
                    <i
                      v-if="showStaffNoSuccess"
                      slot="append"
                      class="el-icon-circle-check"
                    ></i>
                    <i
                      v-if="showStaffNoDuplicated"
                      slot="append"
                      class="el-icon-circle-close"
                    ></i>
                  </el-input>
                  <div v-if="showStaffNoDuplicated" class="duplicated_msg">
                    The EmployeeCode you entered is duplicated
                  </div>
                </div>
                <div v-else>
                  <element-component
                    v-if="!col.hide"
                    :id="`v-add-${col.field}`"
                    v-model="form[col.field]"
                    :state="errors.length > 0 ? false : null"
                    :label="col.label"
                    :disabled="col.disabled"
                    :option="col"
                  />
                </div>

                <template v-if="col.disabled && !form[col.field]">
                  <small class="text-primary">{{ col.small }}</small>
                </template>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- submit and reset -->
        <div class="form-add-nav p-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-3"
            :disabled="loading"
            @click.prevent="validationForm"
          >
            {{ $t('_components.btns.save') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
            :disabled="loading"
            @click="resetForm"
          >
            {{ $t('_components.btns.cancel') }}
          </b-button>
        </div>
      </b-form>
    </validation-observer>
    <c-modal
      :visible="showSSOMsg"
      title="msg"
      :message="ssoMsg"
      @close="() => (showSSOMsg = false)"
      @modelConfirm="modelConfirmSSO"
    />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email, confirmed, password } from '@validations'
import Ripple from 'vue-ripple-directive'
import { BCard, BCol, BRow, BFormGroup, BButton, BForm } from 'bootstrap-vue'
import ElementComponent from '@/components/elementComponent.vue'
import MyTooltip from '@/components/myTooltip.vue'
import { staff } from '@/api/staff/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { deepClone } from '@/util/util'
import CModal from '@/components/crud/modal.vue'
import countryCode from '@/util/mobileCode'

export default {
  name: 'FormAdd',
  components: {
    // BCard,
    ElementComponent,
    CModal,
    BCol,
    BRow,
    BFormGroup,
    MyTooltip,
    ValidationProvider,
    ValidationObserver,
    BButton,
    BForm,
  },
  directives: {
    Ripple,
  },
  props: {
    defaultForm: {
      type: Object,
      default: undefined,
    },
  },
  mounted() {
    const newCountryCode = countryCode
    this.countries = newCountryCode
    this.filteredCountries = [...this.countries]
  },
  data() {
    return {
      form: deepClone(this.defaultForm) || {
        companyId: '1123598813738675201',
        mobileCode: '+86',
      },
      disabled: false,
      loading: false,
      showSSOMsg: false,
      showMobileDuplicated: false,
      showMobileSuccess: false,
      showEmailDuplicated: false,
      showEmailSuccess: false,
      showStaffNoDuplicated: false,
      showStaffNoSuccess: false,
      mobileTimer: null,
      emailTimer: null,
      staffNoTimer: null,
      ssoMsg: '',
      countries: [],
      filteredCountries: [],
      // 规则
      required,
      password,
      email,
      confirmed,
      addTemp: {
        mobile: '735141776417',
        cnName: '黄明',
        enName: 'Helen Martinez',
        nationality: 2,
        sex: 1,
        birthday: '2013-02-06',
        nric: '7832039723079608',
        email: 'j.tojeg@ddinhbldx.at',
        postId: 430000200501066700,
        companyId: 34000019710227356,
        deptId: 150000197704095740,
        createDept: 63000019740817520,
        passportExpiryDate: '1997-10-23',
        isCreate: 1,
        contractPeriodDate: '1996-05-20',
        passportNumber: 'KYN$a',
        staffNo: 'EKj',
        basicSalary: 352964.42,
        account: 'eNz7',
        postcode: 'BLY',
        id: 370000197106308300,
        address: 'vC5z',
        entrySource: 1,
        status: 1,
        contractIssueDate: '2008-07-28',
        wpNumber: '7mT',
        name: '#kTX[2%',
        photo: null,
        password: 'H%Ne',
        passportIssuancePlace: 'w(u$3',
        wpExpiryDate: '1982-08-12',
        isDeleted: 0,
        joinDate: '1988-10-13',
        contractLastUpdateDate: '2011-03-08',
        wpIssueDate: '1982-05-29',
        highestEducation: 'xt8NgQV',
        wpLastUpdateDate: '2001-04-02',
        level: 2,
      },
    }
  },
  computed: {
    columnsPersonal() {
      const columnsTemp = [
        {
          label: this.i18n('label.enName'),
          field: 'enName',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.cnName'),
          field: 'cnName',
          searchSpan: 2,
        },
        {
          label: this.i18n('label.nationality'),
          field: 'nationality',
          type: 'select',
          dictCode: 'nationality',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.sex'),
          field: 'sex',
          type: 'select',
          searchSpan: 2,
          dictBizCode: 'gender',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.birthday'),
          field: 'birthday',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.nric'),
          field: 'nric',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.mobile'),
          field: 'mobile',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.email'),
          field: 'email',
          formOption: {
            rules: 'required|email',
          },
        },
        {
          label: this.i18n('label.postcode'),
          field: 'postcode',
        },
        {
          label: this.i18n('label.passportNumber'),
          field: 'passportNumber',
        },
        {
          label: this.i18n('label.passportExpiryDate'),
          field: 'passportExpiryDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          disabled: !this.form.passportNumber,
          small:
            this.$t('_components.placeholder.firstInput') +
            this.i18n('label.passportNumber'),
        },
        {
          label: this.i18n('label.passportIssuancePlace'),
          field: 'passportIssuancePlace',
          disabled: !this.form.passportNumber,
          small:
            this.$t('_components.placeholder.firstInput') +
            this.i18n('label.passportNumber'),
        },
        {
          label: this.i18n('label.address'),
          field: 'address',
        },
        {
          label: this.i18n('label.vaccinationStatus'),
          field: 'vaccinationStatus',
          type: 'select',
          dictBizCode: 'vaccination_status',
        },
        {
          label: this.i18n('label.religion'),
          field: 'religion',
          type: 'select',
          dictBizCode: 'religion',
        },
        {
          label: this.i18n('label.race'),
          field: 'race',
          type: 'select',
          dictBizCode: 'race',
        },
        {
          label: this.i18n('label.idType'),
          field: 'idType',
          type: 'select',
          dictBizCode: 'id_type',
        },
        {
          label: this.i18n('label.birthCountry'),
          field: 'birthCountry',
          fieldDict: 'birthCountryName',
          type: 'select',
          dictCode: 'nationality',
        },
        {
          label: this.i18n('label.birthCity'),
          field: 'birthCity',
          type: 'select',
          dictCode: 'city',
          dictQuery: {
            code: this.form.birthCountry,
          },
          disabled: !this.form.birthCountry,
          small:
            this.$t('_components.placeholder.firstSelect') +
            this.i18n('label.birthCountry'),
        },
        {
          label: this.i18n('label.highestEducation'),
          field: 'highestEducation',
          type: 'select',
          dictBizCode: 'qualification',
          // disabled: !this.form.university,
          // small: this.$t('_components.placeholder.firstSelect') + this.i18n('labelEdu.university'),
        },
        {
          label: this.i18n('label.marriageStatus'),
          field: 'marriageStatus',
          fieldDict: 'marriageStatusName',
          type: 'select',
          dictBizCode: 'staff_marital_status',
        },
        {
          label: this.i18n('label.isCreate'),
          field: 'isCreate',
          type: 'radio',
          dictCode: 'yes_no',
          hide: true,
        },
        {
          label: this.i18n('label.annualLeaveCategory'),
          field: 'annualLeaveCategory',
          type: 'select',
          fieldDict: 'annualLeaveCategoryName',
          dictBizCode: 'annual_leave_category',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('label.photo'),
          field: 'photo',
          type: 'upload',
          uploadLimit: 10,
          span: 'auto',
        },
        {
          label: this.i18n('label.sign'),
          field: 'sign',
          type: 'upload',
          uploadLimit: 10,
          span: 'auto',
        },
      ]
      const columns = []
      columnsTemp.forEach((item) => {
        const params = item
        const searchObj = this.defaultForm
          ? this.defaultForm[item.field]
          : undefined
        if (searchObj) {
          params.disabled = true
        }
        columns.push(params)
      })
      return columns
    },
    columnsEmployment() {
      const columnsTemp = [
        {
          label: this.i18n('labelEmployment.staffNo'),
          field: 'staffNo',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('labelEmployment.companyId'),
          field: 'companyId',
          type: 'select',
          dictCode: 'company',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('labelEmployment.deptId'),
          field: 'deptId',
          type: 'select',
          dictCode: 'dept',
          dictQuery: {
            parentId: this.form.companyId,
          },
          disabled: !this.form.companyId,
          small:
            this.$t('_components.placeholder.firstInput') +
            this.i18n('labelEmployment.companyId'),
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('labelEmployment.postId'),
          field: 'postId',
          type: 'select',
          dictCode: 'post',
          dictQuery: {
            deptId: this.form.deptId,
          },
          disabled: !this.form.deptId,
          small:
            this.$t('_components.placeholder.firstInput') +
            this.i18n('labelEmployment.deptId'),
          formOption: {
            dictQuery: {
              category: '1',
            },
          },
        },
        {
          label: 'Category',
          field: 'category',
          fieldDict: 'categoryName',
          type: 'select',
          dictBizCode: 'staff_category',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: 'UEN',
          field: 'signCompany',
          type: 'select',
          fieldDict: 'uen',
          dictCode: 'uenCompany',
          formOption: {
            rules: 'required',
          },
        },
        // {
        //   label: `Sign ${this.i18n('labelEmployment.signCompany')}`,
        //   field: 'signCompany',
        //   type: 'select',
        //   fieldDict: 'signCompanyName',
        //   dictCode: 'company',
        //   formOption: {
        //     rules: 'required',
        //   },
        // },
        // {
        //   label: this.i18n('labelEmployment.grade'),
        //   field: 'grade',
        //   type: 'select',
        //   dictBizCode: 'grade',
        // },
        {
          label: this.i18n('labelEmployment.status'),
          field: 'status',
          type: 'select',
          dictBizCode: 'staff_status',
        },
        {
          label: this.i18n('labelEmployment.jobTitle'),
          field: 'jobTitle',
          type: 'select',
          dictBizCode: 'job_title',
        },
        {
          label: this.i18n('labelEmployment.level'),
          field: 'level',
          type: 'select',
          dictBizCode: 'Level',
        },
        {
          label: this.i18n('labelEmployment.wpNumber'),
          field: 'wpNumber',
        },
        {
          label: this.i18n('labelEmployment.wpExpiryDate'),
          field: 'wpExpiryDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          disabled: !this.form.wpNumber,
          small:
            this.$t('_components.placeholder.firstInput') +
            this.i18n('labelEmployment.wpNumber'),
        },
        {
          label: this.i18n('labelEmployment.wpIssueDate'),
          field: 'wpIssueDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          disabled: !this.form.wpNumber,
          small:
            this.$t('_components.placeholder.firstInput') +
            this.i18n('labelEmployment.wpNumber'),
        },
        {
          label: this.i18n('labelEmployment.contractIssueDate'),
          field: 'contractIssueDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.contractPeriodDate'),
          field: 'contractPeriodDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.joinDate'),
          field: 'joinDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.entrySource'),
          field: 'entrySource',
          type: 'select',
          dictBizCode: 'staff_entry_source',
        },
      ]
      const columns = []
      columnsTemp.forEach((item) => {
        const params = item
        const searchObj = this.defaultForm
          ? this.defaultForm[item.field]
          : undefined
        if (searchObj) {
          params.disabled = true
        }
        columns.push(params)
      })
      return columns
    },
  },
  created() {
    this.form.isCreate = '1'
  },
  methods: {
    // i18n
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    modelConfirmSSO() {
      const startIndex = this.ssoMsg.indexOf('[')
      const endIndex = this.ssoMsg.indexOf(']')
      const employeeCode = this.ssoMsg.substring(startIndex + 1, endIndex)
      const { form } = this
      form.originalStaffNo = employeeCode || ''

      Object.keys(form).forEach((key) => {
        const element = form[key]
        if (!element && element !== 0) {
          delete form[key]
        }
      })

      // form.isCreate = form.isCreate === 1 || form.isCreate === '1'
      form.isCreate = true
      staff.add(form).then((res) => {
        this.showSSOMsg = false
        this.$emit('close')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
      })
    },
    mobileInput(e) {
      clearTimeout(this.mobileTimer)
      this.mobileTimer = setTimeout(() => {
        if (e != '') {
          this.verifyContent(`${this.form.mobileCode} ${e}`, 1)
        } else {
          this.showMobileDuplicated = false
          this.showMobileSuccess = false
        }
      }, 1000)
    },
    mobileCodeChange(e) {
      clearTimeout(this.mobileTimer)
      this.mobileTimer = setTimeout(() => {
        if (e != '') {
          this.verifyContent(`${e} ${this.form.mobile}`, 1)
        } else {
          this.showMobileDuplicated = false
          this.showMobileSuccess = false
        }
      }, 1000)
    },
    emailInput(e) {
      clearTimeout(this.emailTimer)
      this.emailTimer = setTimeout(() => {
        if (e != '') {
          this.verifyContent(`${e}`, 2)
        } else {
          this.showEmailDuplicated = false
          this.showEmailSuccess = false
        }
      }, 1000)
    },
    StaffNoInput(e) {
      clearTimeout(this.staffNoTimer)
      this.staffNoTimer = setTimeout(() => {
        if (e != '') {
          this.verifyContent(`${e}`, 0)
        } else {
          this.showStaffNoDuplicated = false
          this.showStaffNoSuccess = false
        }
      }, 1000)
    },
    verifyContent(content, type) {
      staff
        .verifyRepeat({
          verifyContent: content,
          verifyType: type,
        })
        .then((res) => {
          console.log(res)
          const haveSame = res.data.data
          if (type == 1) {
            this.showMobileDuplicated = haveSame
            this.showMobileSuccess = !haveSame
          }
          if (type == 2) {
            console.log('sdff email', haveSame)
            this.showEmailDuplicated = haveSame
            this.showEmailSuccess = !haveSame
          }
          if (type == 0) {
            console.log('sdff staffNo', haveSame)
            this.showStaffNoDuplicated = haveSame
            this.showStaffNoSuccess = !haveSame
          }
        })
    },
    customFilter(query) {
      // en: item.en,
      //   cn: item.cn,
      //   code: item.code,
      //   zone
      console.log(query)
      const searchTerm = query.toLowerCase()

      this.filteredCountries = this.countries.filter((country) => {
        return (
          country.en.toLowerCase().includes(searchTerm) || // 匹配国家名称
          country.cn.toLowerCase().includes(searchTerm) ||
          country.code.toLowerCase().includes(searchTerm) ||
          country.zone.toLowerCase().includes(searchTerm)
          // 匹配区号
        )
      })
    },
    validationForm() {
      console.log('sss')
      if (
        this.showEmailDuplicated ||
        this.showMobileDuplicated ||
        this.showStaffNoDuplicated
      ) {
        return
      }

      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          // const { form } = this
          const form = deepClone(this.form)
          if (form.photo && form.photo.length) {
            form.photo = form.photo.map((o) => o.attachId).join()
          }
          if (form.sign && form.sign.length) {
            form.sign = form.sign.map((o) => o.attachId).join()
          }

          Object.keys(form).forEach((key) => {
            const element = form[key]
            if (!element && element !== 0) {
              delete form[key]
            }
          })

          // form.isCreate = form.isCreate === 1 || form.isCreate === '1'
          form.isCreate = true
          console.log(form)
          form.staffNo = form.staffNo.trim()
          form.mobile = `${this.form.mobileCode} ${this.form.mobile}`
          staff.add(form).then((res) => {
            console.log(res, res.data.code, res.data.msg)
            if (res.data.code === 10136) {
              this.showSSOMsg = true
              this.ssoMsg = res.data.msg
            } else {
              this.$emit('close')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('_default.toast.title'),
                  icon: 'BellIcon',
                  text: this.$t('_default.toast.text.success'),
                  variant: 'success',
                },
              })
            }
          })
        }
      })
    },
    resetForm() {
      this.form = {}
    },
    hasRequired(option = {}) {
      const rules = option.rules || ''
      return rules.indexOf('required') !== -1
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/form/index.scss';
.form-add {
  &-nav {
    font-size: 20px;
    font-weight: 400;
    color: #13419d;
    line-height: 28px;
    overflow-x: hidden;
  }
  &-line {
    width: 100%;
    border-bottom: 1px solid #cad6eb;
  }
  &-body {
    box-sizing: border-box;
  }
}
.NoduplicatedBox {
  ::v-deep .el-input__inner {
    border-color: #67c23a;
    border-right: none;
  }
  ::v-deep .el-input-group__append {
    border-color: #67c23a;
    background-color: #fff;
    i {
      color: #67c23a !important;
    }
  }
  ::v-deep .el-input-group__prepend {
    border-color: #67c23a;
  }
  .duplicated_msg {
    color: #f56c6c;
  }
}
.duplicatedBox {
  ::v-deep .el-input__inner {
    border-color: #f56c6c;
    border-right: none;
  }
  ::v-deep .el-input-group__append {
    border-color: #f56c6c;
    background-color: #fff;
    i {
      color: #f56c6c !important;
    }
  }
  ::v-deep .el-input-group__prepend {
    border-color: #f56c6c;
  }
  .duplicated_msg {
    color: #f56c6c;
  }
}
</style>
